"use strict";
// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Humla Health API
 * Humla Health API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ContentBlockDtoMimeTypeEnum = exports.ContentBlockDtoTypeEnum = void 0;
exports.instanceOfContentBlockDto = instanceOfContentBlockDto;
exports.ContentBlockDtoFromJSON = ContentBlockDtoFromJSON;
exports.ContentBlockDtoFromJSONTyped = ContentBlockDtoFromJSONTyped;
exports.ContentBlockDtoToJSON = ContentBlockDtoToJSON;
exports.ContentBlockDtoToJSONTyped = ContentBlockDtoToJSONTyped;
/**
 * @export
 */
exports.ContentBlockDtoTypeEnum = {
    Text: 'text',
    Image: 'image'
};
/**
 * @export
 */
exports.ContentBlockDtoMimeTypeEnum = {
    ImageJpeg: 'image/jpeg',
    ImagePng: 'image/png',
    ImageWebp: 'image/webp',
    ImageGif: 'image/gif',
    ApplicationPdf: 'application/pdf'
};
/**
 * Check if a given object implements the ContentBlockDto interface.
 */
function instanceOfContentBlockDto(value) {
    if (!('type' in value) || value['type'] === undefined)
        return false;
    return true;
}
function ContentBlockDtoFromJSON(json) {
    return ContentBlockDtoFromJSONTyped(json, false);
}
function ContentBlockDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'type': json['type'],
        'text': json['text'] == null ? undefined : json['text'],
        'id': json['id'] == null ? undefined : json['id'],
        'name': json['name'] == null ? undefined : json['name'],
        'input': json['input'] == null ? undefined : json['input'],
        'url': json['url'] == null ? undefined : json['url'],
        'mimeType': json['mimeType'] == null ? undefined : json['mimeType'],
    };
}
function ContentBlockDtoToJSON(json) {
    return ContentBlockDtoToJSONTyped(json, false);
}
function ContentBlockDtoToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'type': value['type'],
        'text': value['text'],
        'id': value['id'],
        'name': value['name'],
        'input': value['input'],
        'url': value['url'],
        'mimeType': value['mimeType'],
    };
}
//# sourceMappingURL=ContentBlockDto.js.map